import React from 'react';
import { EMAIL_CONFIG } from '../config/constants';

/**
 * Contenu aligné sur l’écran mobile ConditionsUtilisationScreen.tsx
 * (SuiviFinance_local/screens/ConditionsUtilisationScreen.tsx).
 */
const Terms: React.FC = () => {
  const contactMail = EMAIL_CONFIG.CONTACT;

  return (
    <div className="p-6">
      <div className="card">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-white">Conditions d&apos;utilisation de SuiviFinance</h1>
          <p className="text-dark-400 mt-1">
            Veuillez lire attentivement ces conditions avant d&apos;utiliser l&apos;application.
          </p>
        </div>

        <p className="text-sm text-dark-400 mb-6">
          Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
        </p>

        <section className="space-y-3">
          <h2 className="text-primary-500 text-xl font-semibold border-b border-dark-700 pb-2">
            1. Acceptation des conditions
          </h2>
          <p className="text-white">
            En utilisant l&apos;application SuiviFinance, vous acceptez d&apos;être lié par les présentes conditions
            d&apos;utilisation. Si vous n&apos;acceptez pas ces conditions, veuillez ne pas utiliser l&apos;application.
          </p>
        </section>

        <section className="mt-6 space-y-3">
          <h2 className="text-primary-500 text-xl font-semibold border-b border-dark-700 pb-2">
            2. Description du service
          </h2>
          <p className="text-white">
            SuiviFinance est une application de gestion financière personnelle qui permet aux utilisateurs de suivre
            leurs dépenses, revenus, et de gérer leur budget. L&apos;application est fournie &quot;telle quelle&quot; et nous ne
            garantissons pas qu&apos;elle répondra à vos exigences spécifiques ou qu&apos;elle fonctionnera sans interruption.
          </p>
        </section>

        <section className="mt-6 space-y-3">
          <h2 className="text-primary-500 text-xl font-semibold border-b border-dark-700 pb-2">
            3. Confidentialité et sécurité des données
          </h2>
          <p className="text-white">
            Nous prenons la confidentialité de vos données très au sérieux. Toutes les données financières que vous
            saisissez dans l&apos;application sont stockées de manière sécurisée et ne sont pas partagées avec des tiers
            sans votre consentement explicite. Pour plus d&apos;informations, veuillez consulter notre politique de confidentialité.
          </p>
        </section>

        <section className="mt-6 space-y-3">
          <h2 className="text-primary-500 text-xl font-semibold border-b border-dark-700 pb-2">
            4. Comptes utilisateurs
          </h2>
          <p className="text-white">
            Pour utiliser certaines fonctionnalités de SuiviFinance, vous devez créer un compte. Vous êtes responsable
            de maintenir la confidentialité de vos informations de connexion et de toutes les activités qui se produisent
            sous votre compte. Vous acceptez de nous informer immédiatement de toute utilisation non autorisée de votre compte.
          </p>
        </section>

        <section className="mt-6 space-y-3">
          <h2 className="text-primary-500 text-xl font-semibold border-b border-dark-700 pb-2">
            5. Limitations de responsabilité
          </h2>
          <p className="text-white">
            En aucun cas, les développeurs de SuiviFinance ne seront responsables des dommages directs, indirects,
            accessoires, spéciaux, consécutifs ou punitifs, y compris, mais sans s&apos;y limiter, la perte de profits,
            de données, d&apos;utilisation, de bonne volonté ou d&apos;autres pertes intangibles, résultant de votre accès à
            ou de l&apos;utilisation ou de l&apos;impossibilité d&apos;utiliser l&apos;application.
          </p>
        </section>

        <section className="mt-6 space-y-3">
          <h2 className="text-primary-500 text-xl font-semibold border-b border-dark-700 pb-2">
            6. Modifications des conditions
          </h2>
          <p className="text-white">
            Nous nous réservons le droit de modifier ces conditions d&apos;utilisation à tout moment. Les modifications
            entreront en vigueur dès leur publication dans l&apos;application. Votre utilisation continue de l&apos;application
            après la publication des modifications constitue votre acceptation de ces modifications.
          </p>
        </section>

        <section className="mt-6 space-y-3">
          <h2 className="text-primary-500 text-xl font-semibold border-b border-dark-700 pb-2">
            7. Résiliation
          </h2>
          <p className="text-white">
            Nous nous réservons le droit de suspendre ou de résilier votre accès à l&apos;application à tout moment,
            pour quelque raison que ce soit, sans préavis ni responsabilité.
          </p>
        </section>

        <section className="mt-6 space-y-3">
          <h2 className="text-primary-500 text-xl font-semibold border-b border-dark-700 pb-2">
            8. Loi applicable
          </h2>
          <p className="text-white">
            Ces conditions sont régies par les lois en vigueur en France, sans égard aux principes de conflits de lois.
          </p>
        </section>

        <section className="mt-6 space-y-3">
          <h2 className="text-primary-500 text-xl font-semibold border-b border-dark-700 pb-2">
            9. Contact
          </h2>
          <p className="text-white">
            Si vous avez des questions concernant ces conditions d&apos;utilisation, veuillez nous contacter à{' '}
            <a
              className="text-primary-400 hover:text-primary-300 underline"
              href={`mailto:${contactMail}`}
            >
              {contactMail}
            </a>
            .
          </p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
